<form class="layout-form" [formGroup]="contactForm" (ngSubmit)="onSubmit()">
  <div class="component-content">
    <div class="form-header" [ngClass]="{ 'shadow-top': shadowScroll.showShadowTop }">
      <p>Informações de contato e entrega</p>
      <span> Insira suas informações de contato e recepção de bebidas </span>
    </div>
    <div class="scroll-display" (scroll)="onScroll($event)">
      <div class="form-select-content">
        <app-file-upload-component
          *ngFor="let file of files; let i = index"
          [labelText]="file.label"
          [isImg]="file.isImg"
          [extensions]="file.extensions"
          [documentId]="file.documentId"
          [formControlName]="'uploadFile' + i"
          [maxSizeFile]="file.size"
          [id]="'file' + i"
          [required]="false"
          [submitted]="submitted"
        ></app-file-upload-component>
      </div>

      <div class="form-select-content">
        <app-text-input
          data-testid="input-email"
          [labelText]="'Email do comerciante ou proprietário'"
          [type]="'email'"
          [subText]="'Ingrese una dirección válida'"
          [required]="true"
          formControlName="email"
          [submitted]="submitted"
        ></app-text-input>
      </div>

      <div class="form-select-content">
        <label class="input-label">Celular da empresa ou do proprietário</label>
        <div class="phone-inputs-container">
          <app-text-input
            class="number"
            data-testid="numero-cel"
            [labelText]="'Número'"
            [type]="'telephone-number'"
            [subText]="'Incluir código de país y área'"
            [required]="true"
            formControlName="telephoneNumber"
            [submitted]="submitted"
            [placeholder]="'99 999999999'"
          ></app-text-input>
        </div>
        <div class="warning-label" *ngIf="submitted && validationLenthTelephone('principal')">
          Comprimento de número de célula inválido (11 dígitos)
        </div>
      </div>

      <div class="form-select-content">
        <label class="input-label">Telefone do Comerciante ou Proprietário (opcional)</label>
        <div class="phone-inputs-container">
          <app-text-input
            data-testid="numero-cel-secundario"
            class="number"
            [labelText]="'Número'"
            [type]="'telephone-number-optional'"
            [subText]="'Incluir código de país y área'"
            formControlName="secondaryTelephoneNumber"
            [submitted]="submitted"
            [placeholder]="'99 999999999'"
          ></app-text-input>
        </div>
        <div class="warning-label" *ngIf="submitted && validationLenthTelephone('optional')">
          Comprimento do número do comerciante inválido (11 dígitos)
        </div>
      </div>
      <div class="form-select-content">
        <div>
          <app-radio-button
            [formControlName]="'localOpening'"
            [required]="true"
            [labelText]="'O seu estabelecimento já foi inaugurado?'"
            [optionOne]="'Não'"
            [optionTwo]="'Sim'"
          >
          </app-radio-button>
        </div>
        <div class="component-input" [@fadeInOut] *ngIf="this.contactForm.controls['localOpening'].value == 'false'">
          <app-date-picker
            [minDate]="minDate"
            [formControlName]="'dateOpening'"
            [required]="true"
            [labelText]="'Informe a data prevista para inauguração Ex. 11/11/11            '"
          ></app-date-picker>
        </div>
      </div>
      <div class="form-select-content">
        <label class="label-time">horário de funcionamento</label>
        <div class="time-picker--content">
          <app-time-picker
            [attr.data-testid]="'picker-franja-mañana-inicio'"
            [timeTo]="timeA.end"
            [timeFrom]="timeA.start"
            [sumeTime]="sumeTime"
            [submitted]="submitted"
            formControlName="timeAStart"
          ></app-time-picker>
          <span class="time-picker--separator">-</span>
          <app-time-picker
            [attr.data-testid]="'picker-franja-mañana-final'"
            [timeTo]="timeA.end"
            [timeFrom]="timeA.start"
            [sumeTime]="sumeTime"
            [submitted]="submitted"
            formControlName="timeAEnd"
          ></app-time-picker>
        </div>
        <div
          class="warning-label"
          *ngIf="
            !validationPicker(
              this.contactForm.controls['timeAStart'].value,
              this.contactForm.controls['timeAEnd'].value,
              this.contactForm.controls['timeAStart'].dirty,
              this.contactForm.controls['timeAEnd'].dirty
            )
          "
        >
          Agendamento inválido
        </div>
      </div>
      <div class="form-checkbox">
        <mat-checkbox
          [attr.data-testid]="'check-terminos-condiciones'"
          formControlName="conditionsAndTerms"
        ></mat-checkbox>
        <p class="form-checkbox--text">
          <span> Eu aceito os </span>
          <span class="form-terms-conditions" (keydown)="openTermsDialogOnKeyDown($event)" (click)="openTermsDialog()">
            termos e condições</span
          >
        </p>
      </div>
      <div class="warning-label" *ngIf="submitted && !this.contactForm.controls['conditionsAndTerms'].valid">
        Debes acceptar los términos y condiciones.
      </div>
    </div>
  </div>
  <div class="form-navigation" [ngClass]="{ 'shadow-bottom': shadowScroll.showShadowBottom }">
    <app-navigation [currentStep]="5" [countSteppers]="5"></app-navigation>
  </div>
  <div class="button-container">
    <button mat-raised-button class="back-button" type="button" (click)="back()">Antigo</button>
    <button mat-raised-button class="next-button next-button__60" type="submit">Seguindo</button>
  </div>
</form>
